import React from 'react';
import { Text, View } from 'react-native';
import FullPageSimulator from '../FullPageSimulator';
import {
  textPrimary_10_4,
  textPrimary_11_6,
  textPrimary_9_3,
  textSecondary_7_0,
} from '../../AuxiliaryComponent/TextComponent/TextStyle';
import { Cancel_transfer, Resend_SMS, Transaction_pending } from '../../../../utils/DictionaryManagementUtils';
//= ========================================================================

const TransactionDetailsFP = ({
  globJSON,
  simPlatform,
  headlineText,
  TopTitle,
  slideshowRefs = null,
  twoActions,
  transactionsList,
}) => {
  const myStyles = {
    container: {
      marginHorizontal: 17,
    },
    detailsSpace: {
      height: 6,
      width: 1,
    },
    transferButton: {
      height: 40,
      width: 240,
      marginTop: 1,
      marginLeft: 0,
      position: 'absolute',
      bottom: 0,
      backgroundColor: globJSON.configurations.theme.colors.app_background_color,
      boxShadow: '0 0 6px 0 rgba(0, 109, 199, 0.22)',
      paddingVertical: 5.5,
      paddingHorizontal: 17.5,
      flexDirection: 'row',
      gap: 8,
    },
    resendButton: {
      height: '100%',
      width: '100%',
      boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.1)',
      border: 'solid 1px #cbd5e0',
      fontWeight: 'bold',
      borderRadius: 5,
      textAlign: 'center',
      paddingVertical: 7,
    },
  };

  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      headlineText={headlineText}
      TopTitle={TopTitle}
      slideshowRefs={slideshowRefs}
      floatingChildren={(
        <View style={myStyles.transferButton}>
          <Text style={[textPrimary_11_6(globJSON, simPlatform), myStyles.resendButton]}>{Resend_SMS}</Text>
          {twoActions && (<Text style={[textPrimary_11_6(globJSON, simPlatform), myStyles.resendButton]}>{Cancel_transfer}</Text>)}
        </View>
          )}
    >
      {twoActions ? (
        <View style={myStyles.container}>
          {transactionsList.map((transaction) => (
            <View>
              <Text style={[textSecondary_7_0(globJSON, simPlatform), { paddingVertical: 2 }]}>{transaction.txtPrimary}</Text>
              <Text style={[textPrimary_9_3(globJSON, simPlatform), { fontFamily: null }]}>{transaction.txtSecondary}</Text>
              <View style={myStyles.detailsSpace} />
            </View>
          ))}
          <Text style={[textPrimary_9_3(globJSON, simPlatform), { fontFamily: null }]}>{Transaction_pending}</Text>
        </View>
      ) : (
        <View style={myStyles.container}>
          {transactionsList.map((transaction) => (
            <View>
              <Text style={[textSecondary_7_0(globJSON, simPlatform), { paddingVertical: 2 }]}>{transaction.txtPrimary}</Text>
              <Text style={[textPrimary_10_4(globJSON, simPlatform), { fontFamily: null }]}>{transaction.txtSecondary}</Text>
              <View style={myStyles.detailsSpace} />
            </View>
          ))}
        </View>
      )}
    </FullPageSimulator>
  );
};
export default TransactionDetailsFP;
